import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

/**
 * Validador del control `idTracker` de los formularios de activo y colectivo:
 * el activo necesita al menos una fuente de datos, un tracker o una dashcam.
 * Con una dashcam elegida, el tracker deja de ser obligatorio.
 */
export function trackerODashcamRequerido(
  control: AbstractControl,
): ValidationErrors | null {
  const idDashcam = control.parent?.get('idDashcam')?.value;
  return control.value || idDashcam ? null : { required: true };
}

/**
 * Revalida `idTracker` cada vez que cambia `idDashcam`: el validador de arriba
 * depende de los dos controles y Angular sólo lo corre cuando cambia el propio.
 */
export function revalidarTrackerAlCambiarDashcam(form: FormGroup) {
  return form
    .get('idDashcam')
    ?.valueChanges.subscribe(() =>
      form.get('idTracker')?.updateValueAndValidity({ emitEvent: false }),
    );
}
